import React from 'react'
import Link from 'gatsby-link'
import { Gallery, Image } from '../components/LightBox'

const imagesContext = require.context('../images/hair-color')
const images = imagesContext.keys().map(imagesContext)

export default function HairColorPage() {
  return <Gallery title="Hair Color">{images.map(img => <Image src={img} />)}</Gallery>
}



// WEBPACK FOOTER //
// ./src/pages/hair-color.js